import { Box, defineStyle } from '@chakra-ui/react';
import type { ReactNode } from 'react';

export interface MediaCallDragProps {
  fullScreen: boolean;
  children: ReactNode;
  dragRef_: any;
}

const mediaCallModalCss = defineStyle({
  position: 'fixed',
  inset: '0',
  width: '100vw',
  height: '100vh',
  background: 'black',
  zIndex: '1000',
});

const zoomOutCss = defineStyle({
  inset: 'initial',
  top: '100px',
  right: '25px',
  width: '222px',
  height: '325px',
  background: 'none',
});
export function MediaCallDrag(props: MediaCallDragProps) {
  const {
    fullScreen,
    children,
    dragRef_: { dragRef, style },
  } = props;

  return (
    <Box
      id="mediaModal"
      ref={dragRef}
      zIndex={999}
      display={'flex'}
      css={{
        ...mediaCallModalCss,
        ...(fullScreen ? {} : zoomOutCss),
        ...style,
      }}
    >
      {children}
    </Box>
  );
}

export default memo(MediaCallDrag);
